<template>
    <v-row align="center">
        <v-col class="pb-0">
            <v-card elevation="1">
                <v-container fluid pa-0 ma-0>
                    <v-row  justify="space-between">
                        <v-col cols="12" sm="4"
                               class="text-center">
                            <v-card elevation="0" >
                                <v-sheet
                                        color="#24C5D9"
                                        class="v-sheet--offset mx-auto pa-2"
                                        elevation="8"
                                        max-width="calc(100% - 32px)"
                                >
                                    <h5 style="color:white">
                                        Client Information {{id}}
                                    </h5>
                                </v-sheet>
                                <v-card-text class="ma-0" v-if="client.id">
                                    <v-row class="text-left">
                                        <v-col cols="4">
                                            <p>Type: <span style="color:black">
                                                        {{ !!!client.typeName ? 'Unassigned' : client.typeName }}
                                                    </span></p>
                                        </v-col>
                                        <v-col cols="4">
                                            <p>Status: <span style="color:black">
                                                        {{ client.active ? 'active' : 'inactive' }}
                                                    </span></p>
                                        </v-col>
                                        <v-col cols="4">
                                            <p>Assigned To: <span style="color:black">
                                                        {{ client.employees.length }}
                                                    </span>
                                            </p>
                                        </v-col>
                                        <v-col cols="8">
                                            <p>Created Date: <span style="color:black">
                                                        {{ client.fromattedCreatedDate }}
                                                    </span></p>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <!--<v-col cols="12" sm="3"-->
                               <!--class="text-center">-->
                            <!--<v-card elevation="0">-->
                                <!--<v-sheet-->
                                        <!--color="#24C5D9"-->
                                        <!--class="v-sheet&#45;&#45;offset mx-auto pa-2"-->
                                        <!--elevation="8"-->
                                        <!--max-width="calc(100% - 32px)"-->
                                <!--&gt;-->
                                    <!--<h5 style="color:white">Guardian Information</h5>-->
                                <!--</v-sheet>-->
                                <!--<v-card-text v-if="client.id">-->
                                    <!--<v-row class="text-left">-->
                                        <!--<v-col cols="12" lg="6">-->
                                            <!--<p>Name: <span style="color:black">-->
                                                        <!--{{cognitoUser.attributes.name +-->
                                                        <!--' '+ cognitoUser.attributes.family_name}}-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                        <!--<v-col cols="12" lg="6">-->
                                            <!--<p>DOB: <span style="color:black">-->
                                                        <!--{{cognitoUser.attributes.birthdate}}-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                        <!--<v-col cols="12">-->
                                            <!--<p>Company Name: <span style="color:black">-->
                                                        <!--Unassigned-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                    <!--</v-row>-->
                                <!--</v-card-text>-->
                            <!--</v-card>-->
                        <!--</v-col>-->
                        <!--<v-divider vertical></v-divider>-->
                        <!--<v-col cols="12" sm="4"-->
                               <!--class="text-center">-->
                            <!--<v-card elevation="0">-->
                                <!--<v-sheet-->
                                        <!--color="#24C5D9"-->
                                        <!--class="v-sheet&#45;&#45;offset mx-auto pa-2"-->
                                        <!--elevation="8"-->
                                        <!--max-width="calc(100% - 32px)"-->
                                <!--&gt;-->
                                    <!--<h5 style="color:white">Contact Information</h5>-->
                                <!--</v-sheet>-->
                                <!--<v-card-text v-if="client.id">-->
                                    <!--<v-row  class="text-left">-->
                                        <!--<v-col cols="12">-->
                                            <!--<p >Address: <span style="color:black">-->
                                                        <!--{{(cognitoUser.address.addrs + ', '-->
                                                        <!--+ cognitoUser.address.city + ', '-->
                                                        <!--+ cognitoUser.address.state)}}-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                        <!--<v-col cols="12" xl="4">-->
                                            <!--<p>Phone: <span style="color:black">-->
                                                        <!--{{cognitoUser.attributes.phone_number}}-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                        <!--<v-col cols="12" xl="8">-->
                                            <!--<p>Email: <span style="color:black">-->
                                                        <!--{{cognitoUser.attributes.email}}-->
                                                    <!--</span></p>-->
                                        <!--</v-col>-->
                                    <!--</v-row>-->
                                <!--</v-card-text>-->
                            <!--</v-card>-->
                        <!--</v-col>-->
                    </v-row>
                </v-container>
                <v-divider class="my-0 mx-6"></v-divider>
                <v-card-actions>
                    <v-bottom-navigation
                            grow
                            class="elevation-0"
                            :value="activeBtn"
                            color="blue"
                            horizontal
                    >
                        <v-btn>
                            <span>Documents</span>
                            <v-icon>ub-document</v-icon>
                        </v-btn>

                        <v-btn>
                            <span>Clients</span>
                            <v-icon>ub-clients</v-icon>
                        </v-btn>

                        <v-btn>
                            <span>Reports</span>
                            <v-icon>mdi-file</v-icon>
                        </v-btn>
                    </v-bottom-navigation>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import {ALERT_TYPES, WRONG_ID_SUPPLIED} from "@/shared/enums/AlertTexts";

    export default {
        name: "ClientHeaderDetails",
        props:['id'],
        data(){
            return {
                client:{},
                activeBtn: 0,
                address: {
                    addrs:'',
                    apt:'',
                    city:'',
                    state:'',
                    zip_code:'',
                }
            }
        },
        watch:{
            id(val){
                this.initialize()
            }
        },
        methods:{
            async initialize(){
                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getClient',{id: this.id});
                    this.client = this.$store.getters.getClient;

                    if(!this.client.hasOwnProperty('id')) {
                        this.alertType = ALERT_TYPES.ERROR;
                        this.alertText = WRONG_ID_SUPPLIED;
                        this.okCall = () => this.close();
                        this.openAlert = true;
                        return;
                    }
                    else {
                        this.client.guardian_phone_number = this.client.guardian_phone_number.replace(/\+1/,'');
                        let tempAddress = this.client.address.split(TOKEN);
                        this.address = {
                            addrs: tempAddress[0] !== undefined ? tempAddress[0] : '',
                            apt: tempAddress[1] !== undefined ? tempAddress[1] : '',
                            city: tempAddress[2] !== undefined ? tempAddress[2] : '',
                            state: tempAddress[3] !== undefined ? tempAddress[3] : '',
                            zip_code:tempAddress[4] !== undefined ? tempAddress[4] : ''
                        };
                    }
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style scoped>

</style>